import React from "react";
import { get } from "lodash";
import { Card, Typography, List } from "antd";
import { toTitleCase } from "../helper";
const { Title, Text } = Typography;

const Resolution = ({ data, title, bgColor }) => {
  return (
    <div>
      {Object.keys(data || {}).map((item) => {
        const response = get(data, [item, 'response'], {});

        if (!response) return null;
        return (
          <div key={item}>
            <Title className="fs-1">
              {title}
            </Title>
            <Card style={{ backgroundColor: bgColor }} key={item} className="mb-4 py-0 custom-card-resolution" bordered={false} hoverable>
              {Object.keys(response)?.map((key) => {
                const value = response[key];

                if (Array.isArray(value)) {
                  return (
                    <div key={`${item}-${key}`} className="mb-3">
                      {value.length > 0 && (
                        <>
                          <Title level={5}>{toTitleCase(key)}</Title>
                          <List
                            bordered
                            dataSource={value}
                            renderItem={(listItem, i) => (
                              <List.Item key={`${key}-${i}`}>
                                <Text>{toTitleCase(listItem)}</Text>
                              </List.Item>
                            )}
                          />
                        </>
                      )}
                    </div>
                  );
                }
                return null;
              })}
            </Card>
          </div>
        );
      })}
    </div>
  );
};

export default Resolution;
